import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { pick } from 'ramda';
import { useFocus } from 'js/hooks/useFocus';
import { useTranslations } from 'js/hooks/i18n';
import { Icon } from 'js/components/common/Icon';
import { useMyAccountSidebarSelector } from 'js/store/hooks';

import * as hooks from '../../hooks';
import * as actions from '../../store/actions';

import style from './Header.scss';

export const Header = () => {
    const dispatch = useDispatch();
    const translate = useTranslations();
    const [focusRef, setFocus] = useFocus();
    const handleSidebarClose = hooks.useHandleSidebarClose();
    const {
        name,
        isOpened,
        portalPageURL,
        isBackArrowHidden,
        sidebarMenu: { isSubMenuShown }
    } = useMyAccountSidebarSelector(pick(['name', 'isOpened', 'portalPageURL', 'isBackArrowHidden', 'sidebarMenu']));

    const handleBackArrowClick = useCallback(() => {
        portalPageURL ? dispatch(actions.showHomePage()) : dispatch(actions.showMainMenu());
    }, [dispatch, portalPageURL]);

    useEffect(() => {
        if (isOpened) {
            setTimeout(() => {
                setFocus();
            }, 0);
        }
    }, [isOpened, setFocus]);

    return (
        <div className={`${style.header} cms-my-account-sidebar-header`}>
            <span ref={focusRef} tabIndex={-1} aria-hidden={true} />
            {(portalPageURL && !isBackArrowHidden || !portalPageURL && isSubMenuShown) && (
                <div className={style.backIconContainer}>
                    <Icon
                        role="button"
                        type={'back_arrow'}
                        className={style.backIcon}
                        onClick={handleBackArrowClick}
                        aria-label={translate('playtech.mobile.system.myAccountSidebar.header.aria.backArrow')}
                    />
                </div>
            )}
            <p className={style.name}>{name !== null ? name : translate('playtech.mobile.system.myAccountSidebar.header.name')}</p>
            <Icon
                role="button"
                type={'closeDark'}
                className={style.closeIcon}
                onClick={handleSidebarClose}
                aria-label={translate('playtech.mobile.system.myAccountSidebar.header.aria.close')}
            />
        </div>
    );
};
